import React from 'react';
import CMSService from 'services/CMS';
import Item from 'components/Home/SmallInformative/Item';
import Slider from 'components/Slider';
import style from './style.scss';//NOSONAR

const SmallInformative = (props) => {
    const {data, dateServer} = props;
    if(!data || !data.category) return false;
    
    const category = data?.category.filter(item => item.active && CMSService.validDatesItem(item, dateServer)).slice(0, 4);

    if(category && category.length < 4) return '';

    return(
        <section className='small-informative'>
            <Slider>
                {category && category.map((item, i) => (
                    <Item
                        item={item}
                        key={i}
                        position={'slot'+(i+1)}
                    />
                ))}
            </Slider>  
        </section>
    )
}

export default SmallInformative;